exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ app-input-time input[formcontrolname]:not([type='checkbox']):not([type='radio']):not([type='submit']) {\n  height: 28px !important;\n  font-size: 15px !important;\n  text-align: right;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/change-status-to-complete/change-status-to-complete.component.scss
// module id = 2117
// module chunks = 66